(function () {
  'use strict';

  /** @type {((card: Element) => void) | null} */
  let syncCollectionOpenrunPro2CardRef = null;

  window.syncCollectionOpenrunPro2LwPrice = function (card) {
    if (typeof syncCollectionOpenrunPro2CardRef === 'function') {
      syncCollectionOpenrunPro2CardRef(card);
    }
  };

  function getPromo() {
    return window.__lwPromo || null;
  }

  function isPromoActive() {
    const promo = getPromo();
    if (!promo || promo.active === false) {
      return false;
    }
    if (promo.endsAt) {
      const end = Date.parse(String(promo.endsAt).replace(' UTC', 'Z'));
      if (!Number.isNaN(end) && Date.now() >= end) {
        return false;
      }
    }
    return true;
  }

  function isLoggedIn() {
    return Boolean(window.customer && window.customer.id);
  }

  function isMember() {
    const fromTags = Boolean(
      window.customer &&
        window.customer.tags &&
        window.customer.tags.indexOf('ShokzSquad') !== -1
    );
    const fromShokzMember = Boolean(
      window.ShokzMember &&
        typeof window.ShokzMember.isMember === 'function' &&
        window.ShokzMember.isMember()
    );
    return fromTags || fromShokzMember;
  }

  function isPromoVariant(variantId) {
    const promo = getPromo();
    if (!promo || !promo.variantIds) return false;
    return promo.variantIds.map(String).indexOf(String(variantId)) !== -1;
  }

  function isInactiveVariant(variantId) {
    const promo = getPromo();
    if (!promo || !promo.inactiveVariantIds || !variantId) return false;
    return promo.inactiveVariantIds.map(String).indexOf(String(variantId)) !== -1;
  }

  function shouldUseMemberPromoPrice() {
    const promo = getPromo();
    return promo ? promo.showMemberPromoPrice !== false : true;
  }

  function shouldShowMemberPrice() {
    return isPromoActive() && isMember() && shouldUseMemberPromoPrice();
  }

  function shouldShowMemberPriceForVariant(variantId) {
    return shouldShowMemberPrice() && !isInactiveVariant(variantId);
  }

  function getListJoinLabel() {
    const promo = getPromo();
    return (promo && promo.listJoinButtonLabel) || 'Join Now';
  }

  function getHubUrl() {
    const promo = getPromo();
    return (promo && promo.hubUrl) || '/pages/shokzsquad-signup';
  }

  function shouldShowListJoinButton(variantId) {
    return isPromoActive() && isPromoVariant(variantId) && !isMember();
  }

  function setJoinRedirectFlag(el, shouldRedirect) {
    if (!el) return;
    if (shouldRedirect) {
      el.dataset.lwJoinRedirect = '1';
    } else {
      delete el.dataset.lwJoinRedirect;
    }
  }

  function buildPdpSalePriceHtml(memberPrice, comparePrice) {
    const promo = getPromo();
    const badgeLabel = (promo && promo.badgeLabel) || 'member price';
    return (
      '<div class="lw-promo-price-block main-price">' +
      '<div class="lw-promo-price__badge">' +
      badgeLabel +
      '</div>' +
      '<div class="price price--large lw-promo-price">' +
      '<span class="lw-promo-price__member">' +
      memberPrice +
      '</span>' +
      '<span class="lw-promo-price__compare">' +
      comparePrice +
      '</span></div></div>'
    );
  }

  function getActiveVariantIdFromPdp() {
    const wrapper = document.querySelector('.product__info-wrapper');
    if (wrapper && wrapper.dataset.variantId) {
      return wrapper.dataset.variantId;
    }
    const input = document.querySelector('.product-form input[name="id"]');
    return input ? input.value : null;
  }

  function syncModelVariantTagPrice() {
    const memberEl = document.querySelector('.product__info-wrapper .lw-promo-price__member');
    const saleEl = document.querySelector('.product__info-wrapper .price__sale .price-item--last');
    const priceText = memberEl
      ? memberEl.textContent.trim()
      : saleEl
        ? saleEl.textContent.trim()
        : '';
    if (!priceText || typeof window.$ !== 'function') return;
    window.$('.model_variant_wrapper .model_item.active .tag').text(priceText);
  }

  function updateLunarWhiteMemberPrice() {
    const promo = getPromo();
    if (!promo) {
      syncTipsForNewProduct();
      return;
    }

    const variantId = getActiveVariantIdFromPdp();
    const priceRoot =
      document.querySelector('.product__info-wrapper [id^="price-"]') ||
      document.querySelector('.product__info-wrapper .main-price')?.closest('[id^="price-"]');

    if (!priceRoot || !variantId) {
      updateSubmitButtonLabels();
      syncTipsForNewProduct();
      return;
    }

    if (shouldShowMemberPriceForVariant(variantId)) {
      const priceHtml = buildPdpSalePriceHtml(promo.memberPrice, promo.comparePrice);
      const priceEl = priceRoot.querySelector('.main-price');
      if (priceEl) {
        priceEl.outerHTML = priceHtml;
      } else {
        priceRoot.insertAdjacentHTML('beforeend', priceHtml);
      }
      syncModelVariantTagPrice();
    }

    updateSubmitButtonLabels();
    syncTipsForNewProduct();
  }

  function syncTipsForNewProduct() {
    const tips = document.querySelector('.tips-for-new-product');
    if (!tips) return;

    if (!isPromoActive()) {
      tips.style.removeProperty('display');
      return;
    }

    const variantId = getActiveVariantIdFromPdp();
    if (!variantId) return;

    tips.style.display = isInactiveVariant(variantId) ? 'none' : '';
  }

  const SUBMIT_LABEL_JOIN = 'Join to Save 20%';
  const SUBMIT_LABEL_MEMBER = 'Shop Now | Members Only';
  const SIGNUP_URL = '/pages/shokzsquad-signup';
  const NOTIFY_LABEL_DEFAULT = 'Notify Me at Launch';
  let submitLabelTimer = null;

  function shouldSkipSubmitButton(button) {
    if (!button) return true;
    if (button.disabled || button.getAttribute('data-disabled') === '1') return true;
    if (button.classList.contains('hidden')) return true;

    const span = button.querySelector('span');
    if (!span) return true;

    const text = span.textContent.trim();
    const reservedLabels = ['Discontinued'];
    if (window.variantStrings) {
      if (window.variantStrings.soldOut) reservedLabels.push(window.variantStrings.soldOut);
      if (window.variantStrings.unavailable) reservedLabels.push(window.variantStrings.unavailable);
    }
    return reservedLabels.indexOf(text) !== -1;
  }

  function updateSubmitButtonLabels() {
    if (!isPromoActive()) {
      removeNotifyButtons();
      return;
    }

    const variantId = getActiveVariantIdFromPdp();
    const promoVariant = isPromoVariant(variantId);
    const buttons = document.querySelectorAll('.product-form__buttons .product-form__submit');

    if (!promoVariant) {
      buttons.forEach(function (button) {
        const span = button.querySelector('span');
        if (!span) return;

        if (
          button.disabled ||
          button.getAttribute('data-disabled') === '1' ||
          shouldSkipSubmitButton(button)
        ) {
          delete span.dataset.lwOriginalLabel;
          return;
        }

        if (!span.dataset.lwOriginalLabel) return;
        if (span.textContent.trim() === span.dataset.lwOriginalLabel) {
          delete span.dataset.lwOriginalLabel;
          return;
        }
        span.textContent = span.dataset.lwOriginalLabel;
        delete span.dataset.lwOriginalLabel;
      });
      syncNotifyButton();
      return;
    }

    const loggedIn = isLoggedIn();
    const member = isMember();
    const label = loggedIn && member ? SUBMIT_LABEL_MEMBER : SUBMIT_LABEL_JOIN;

    buttons.forEach(function (button) {
      if (shouldSkipSubmitButton(button)) return;

      const span = button.querySelector('span');
      if (!span) return;

      if (span.textContent.trim() === label) return;

      if (!span.dataset.lwOriginalLabel) {
        span.dataset.lwOriginalLabel = span.textContent.trim();
      }

      span.textContent = label;
    });

    syncNotifyButton();
  }

  function getNotifyButtonLabel() {
    const promo = getPromo();
    return (promo && promo.notifyButtonLabel) || NOTIFY_LABEL_DEFAULT;
  }

  function shouldShowNotifyButton() {
    if (!isPromoActive()) return false;
    const variantId = getActiveVariantIdFromPdp();
    if (!isPromoVariant(variantId)) return false;
    return !(isLoggedIn() && isMember());
  }

  function getMainProductFormButtonGroups() {
    return document.querySelectorAll(
      '.product_template_new .product__info-wrapper .product-form__buttons'
    );
  }

  function removeNotifyButtons(scope) {
    const root = scope || document;
    root.querySelectorAll('.lw-promo-notify-btn').forEach(function (btn) {
      btn.remove();
    });
  }

  function openKlaviyoNotifyForm() {
    const promo = getPromo();
    const formId = promo && promo.klaviyoFormId;

    if (!formId) {
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function syncNotifyButton() {
    const show = shouldShowNotifyButton();
    const label = getNotifyButtonLabel();
    const groups = getMainProductFormButtonGroups();

    if (!show) {
      removeNotifyButtons();
      return;
    }

    groups.forEach(function (buttonsWrap) {
      let btn = buttonsWrap.querySelector('.lw-promo-notify-btn');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lw-promo-notify-btn';
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          trackNotifyButtonClick();
          openKlaviyoNotifyForm();
        });
        buttonsWrap.appendChild(btn);
      }
      btn.textContent = label;
      btn.setAttribute('aria-label', label);
    });
  }

  function scheduleSubmitButtonLabels() {
    if (submitLabelTimer) clearTimeout(submitLabelTimer);
    submitLabelTimer = setTimeout(updateSubmitButtonLabels, 0);
  }

  function observeSubmitButtonDom() {
    const banner = document.querySelector('.product_template_new .section-buy-now-banner-pc');
    if (!banner || typeof MutationObserver === 'undefined') return;

    const observer = new MutationObserver(function (mutations) {
      const hasNewSubmitButton = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          if (typeof node.matches === 'function') {
            if (node.matches('.product-form__submit, .product-form__buttons, product-form')) return true;
          }
          return typeof node.querySelector === 'function' && node.querySelector('.product-form__submit');
        });
      });
      if (hasNewSubmitButton) {
        scheduleSubmitButtonLabels();
        syncNotifyButton();
      }
    });

    observer.observe(banner, { childList: true, subtree: true });
  }

  function shouldRedirectJoinSubmit() {
    if (!isPromoActive()) return false;
    const variantId = getActiveVariantIdFromPdp();
    if (!isPromoVariant(variantId)) return false;
    return !(isLoggedIn() && isMember());
  }

  function isJoinSubmitButton(button) {
    if (!button || shouldSkipSubmitButton(button)) return false;
    const span = button.querySelector('span');
    return Boolean(span && span.textContent.trim() === SUBMIT_LABEL_JOIN);
  }

  function trackJoinSubmitClick() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'PDP_Purchase_Bottom',
        content_name: 'Openrunpro2_PDP',
        button_name: 'Join_Now'
      }
    });
  }

  function trackNotifyButtonClick() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'PDP_Purchase_Bottom',
        content_name: 'Openrunpro2_PDP',
        button_name: 'Notify_Me'
      }
    });
  }

  function redirectJoinSubmit(event) {
    if (!shouldRedirectJoinSubmit()) return false;

    const button =
      event.target && event.target.closest
        ? event.target.closest('.product-form__buttons .product-form__submit')
        : null;
    if (!isJoinSubmitButton(button)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    trackJoinSubmitClick();
    window.location.assign(SIGNUP_URL);
    return true;
  }

  function initJoinSubmitRedirect() {
    const root = document.querySelector('.product_template_new');
    if (!root) return;

    root.addEventListener(
      'click',
      function (event) {
        redirectJoinSubmit(event);
      },
      true
    );

    root.addEventListener(
      'submit',
      function (event) {
        if (!shouldRedirectJoinSubmit()) return;

        const form = event.target;
        if (!form || form.tagName !== 'FORM') return;

        const button = form.querySelector('.product-form__buttons .product-form__submit');
        if (!isJoinSubmitButton(button)) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        trackJoinSubmitClick();
        window.location.assign(SIGNUP_URL);
      },
      true
    );
  }

  function isOpenrunPro2Root(el) {
    if (!el) return false;
    if (el.classList && el.classList.contains('openrunpro2')) return true;
    const item = el.closest('.product-item, product-item, .product_item');
    return Boolean(item && item.classList.contains('openrunpro2'));
  }

  function applyOpenEarPriceWrapper(wrapper, variantId) {
    const promo = getPromo();
    if (!promo || !wrapper) {
      return;
    }

    if (!isOpenrunPro2Root(wrapper)) {
      return;
    }

    const priceEl = wrapper.querySelector('.price-wrapper[data-id="' + variantId + '"]');
    if (!priceEl) {
      return;
    }

    const regular = priceEl.getAttribute('data-regular-price') || priceEl.textContent.trim();

    if (shouldShowMemberPriceForVariant(variantId)) {
      priceEl.innerHTML =
        promo.memberPrice +
        ' <span class="compare_price" style="text-decoration: line-through;font-size:80%;">' +
        promo.comparePrice +
        '</span>';
    } else if (regular) {
      const compareHtml = priceEl.getAttribute('data-compare-html');
      priceEl.innerHTML = regular + (compareHtml || '');
    }
  }

  function initOpenEarPromoPrices() {
    const wrappers = document.querySelectorAll('.openrunpro2 .product-info-wrapper');
    wrappers.forEach(function (wrapper) {
      const variantsData = wrapper.getAttribute('data-variants');
      if (!variantsData) return;
      let variants;
      try {
        variants = JSON.parse(variantsData);
      } catch (e) {
        return;
      }
      const active = variants.find(function (v) {
        return wrapper.querySelector('.product-color-swatch-wrapper .switch.active[data-id="' + v.id + '"]');
      });
      if (active) {
        applyOpenEarPriceWrapper(wrapper, active.id);
        syncOpenEarAddToCartButton(wrapper, active.id);
      }
    });
  }

  function syncOpenEarAddToCartButton(wrapper, variantId) {
    if (!wrapper || !isOpenrunPro2Root(wrapper)) return;

    const btn = wrapper.querySelector('.addtocart-btn');
    const textEl = btn && btn.querySelector('.addtocart-text');
    if (!btn || !textEl) return;

    if (isInactiveVariant(variantId)) return;

    const isSoldOut = btn.dataset.available === 'false' || btn.classList.contains('disable');
    if (isSoldOut) {
      setJoinRedirectFlag(btn, false);
      return;
    }

    if (shouldShowListJoinButton(variantId)) {
      textEl.textContent = getListJoinLabel();
      setJoinRedirectFlag(btn, true);
      return;
    }

    setJoinRedirectFlag(btn, false);
    textEl.textContent = 'Add to Cart';
  }

  function applyCollectionCardPrice(card, variantId) {
    const promo = getPromo();
    if (!promo || !card) {
      return;
    }

    if (!isOpenrunPro2Root(card)) {
      return;
    }

    const row = card.querySelector('.price_list .price[data-id="' + variantId + '"]');
    if (!row) {
      return;
    }

    const cur = row.querySelector('.cur_price');
    const cmp = row.querySelector('.compare_price');
    if (!cur) {
      return;
    }

    const showMember = shouldShowMemberPriceForVariant(variantId);

    if (!row.dataset.lwRegularPrice) {
      row.dataset.lwRegularPrice = cur.textContent.trim();
      if (cmp) {
        row.dataset.lwComparePrice = cmp.textContent.trim();
        row.dataset.lwHadCompare = cmp.textContent.trim() ? '1' : '0';
      } else {
        row.dataset.lwHadCompare = '0';
      }
    }

    if (showMember) {
      cur.textContent = promo.memberPrice;
      if (cmp) {
        cmp.textContent = promo.comparePrice;
        cmp.style.display = '';
      } else {
        const span = document.createElement('span');
        span.className = 'compare_price';
        span.textContent = promo.comparePrice;
        row.appendChild(span);
      }
    } else {
      cur.textContent = row.dataset.lwRegularPrice || cur.textContent;
      if (cmp) {
        if (row.dataset.lwHadCompare === '1' && row.dataset.lwComparePrice) {
          cmp.textContent = row.dataset.lwComparePrice;
          cmp.style.display = '';
        } else {
          cmp.textContent = '';
          cmp.style.display = 'none';
        }
      }
    }
  }

  function syncCollectionOpenrunPro2Card(card) {
    const activeSwatch = card.querySelector('.product-color-swatch-wrapper .swatch.active');

    if (!activeSwatch) {
      const activePrice = card.querySelector('.price_list .price.active');
      if (activePrice) {
        const fallbackVariantId = activePrice.getAttribute('data-id');
        if (fallbackVariantId) {
          applyCollectionCardPrice(card, fallbackVariantId);
        }
      }
      syncCollectionAddToCartButton(card);
      return;
    }

    const variantId = activeSwatch.getAttribute('data-id');
    if (!variantId) {
      return;
    }

    const activePrices = card.querySelectorAll('.price_list .price.active');
    if (activePrices.length) {
      activePrices.forEach(function () {
        applyCollectionCardPrice(card, variantId);
      });
    } else {
      applyCollectionCardPrice(card, variantId);
    }

    syncCollectionAddToCartButton(card);
  }

  function syncCollectionAddToCartButton(card) {
    if (!card || !isOpenrunPro2Root(card)) return;

    const btn = card.querySelector('add-cart-button');
    if (!btn) return;

    if (btn.classList.contains('disabled') || btn.classList.contains('notify')) {
      setJoinRedirectFlag(btn, false);
      return;
    }

    const activeSwatch = card.querySelector('.product-color-swatch-wrapper .swatch.active');
    let variantId = activeSwatch && activeSwatch.getAttribute('data-id');
    if (!variantId) {
      const activePrice = card.querySelector('.price_list .price.active');
      if (activePrice) {
        variantId = activePrice.getAttribute('data-id');
      }
    }
    if (!variantId) return;

    const labelSpan = btn.querySelector('span');
    if (!labelSpan) return;

    if (shouldShowListJoinButton(variantId)) {
      if (!labelSpan.dataset.lwOriginalLabel) {
        labelSpan.dataset.lwOriginalLabel = labelSpan.textContent.trim();
      }
      labelSpan.textContent = getListJoinLabel();
      setJoinRedirectFlag(btn, true);
      return;
    }

    setJoinRedirectFlag(btn, false);
    if (labelSpan.dataset.lwOriginalLabel) {
      labelSpan.textContent = labelSpan.dataset.lwOriginalLabel;
      delete labelSpan.dataset.lwOriginalLabel;
    } else if (labelSpan.textContent.trim() === getListJoinLabel()) {
      labelSpan.textContent = 'Add to Cart';
    }
  }

  let listJoinRedirectsBound = false;

  function initListJoinRedirects() {
    if (listJoinRedirectsBound) return;
    listJoinRedirectsBound = true;

    document.addEventListener(
      'click',
      function (event) {
        const openEarBtn = event.target.closest('.addtocart-btn[data-lw-join-redirect="1"]');
        if (openEarBtn && isOpenrunPro2Root(openEarBtn)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          window.location.assign(getHubUrl());
          return;
        }

        const collectionBtn = event.target.closest('add-cart-button[data-lw-join-redirect="1"]');
        if (collectionBtn && isOpenrunPro2Root(collectionBtn)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          window.location.assign(getHubUrl());
        }
      },
      true
    );
  }

  function initCollectionPromoPrices() {
    const grid = document.getElementById('product-grid');
    if (!grid) {
      return;
    }

    const cardsBySelector = grid.querySelectorAll('product-item.openrunpro2, .product_item.openrunpro2');
    const allProductItems = grid.querySelectorAll('product-item, .product_item');
    const openrunItems = Array.from(allProductItems).filter(function (el) {
      return el.classList.contains('openrunpro2');
    });

    const cards = cardsBySelector.length ? cardsBySelector : openrunItems;

    cards.forEach(function (card) {
      syncCollectionOpenrunPro2Card(card);
    });

    grid.addEventListener(
      'click',
      function (event) {
        const swatch = event.target.closest('.product-color-swatch-wrapper .swatch');
        if (!swatch) return;
        const card = swatch.closest('product-item.openrunpro2, .product_item.openrunpro2') ||
          (swatch.closest('product-item, .product_item')?.classList?.contains('openrunpro2')
            ? swatch.closest('product-item, .product_item')
            : null);
        if (!card) return;
        setTimeout(function () {
          syncCollectionOpenrunPro2Card(card);
        }, 0);
      },
      true
    );

    setTimeout(function () {
      const retryCards = grid.querySelectorAll('product-item.openrunpro2, .product_item.openrunpro2');
      retryCards.forEach(function (card) {
        syncCollectionOpenrunPro2Card(card);
      });
    }, 500);
  }

  syncCollectionOpenrunPro2CardRef = syncCollectionOpenrunPro2Card;

  window.updateLunarWhiteMemberPrice = updateLunarWhiteMemberPrice;
  window.updateLunarWhiteSubmitButtonLabels = updateSubmitButtonLabels;
  window.updateLunarWhiteNotifyButton = syncNotifyButton;
  window.syncTipsForNewProduct = syncTipsForNewProduct;
  window.applyOpenEarLwMemberPrice = applyOpenEarPriceWrapper;
  window.syncOpenEarLwAddToCart = syncOpenEarAddToCartButton;
  window.syncCollectionOpenrunPro2LwPrice = syncCollectionOpenrunPro2Card;
  window.syncCollectionOpenrunPro2LwAddToCart = syncCollectionAddToCartButton;

  document.addEventListener('DOMContentLoaded', function () {
    const promo = getPromo();
    if (!promo) {
      return;
    }

    initListJoinRedirects();
    updateLunarWhiteMemberPrice();
    initJoinSubmitRedirect();
    observeSubmitButtonDom();
    initOpenEarPromoPrices();
    initCollectionPromoPrices();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        updateLunarWhiteMemberPrice();
      });
    }
  });
})();
